import { BlazepayAPI, BlazepayPaymentOptionModels } from '@getgreenline/payments'
import { LocalStorage } from './LocalStorage'

type PaymentOptionsFilter = {
  ecomAvailable?: boolean
  posAvailable?: boolean
  countryCode?: string
}

interface PaymentOptionsWithCacheArgs {
  merchantId: string
  filter?: PaymentOptionsFilter
}

interface PaymentOptionsWithCacheResult {
  data: BlazepayPaymentOptionModels.IPaymentOptionEventOrRestData[]
  fromCache: boolean
}

export const getPaymentOptionsWithCache = async ({
  merchantId,
  filter,
}: PaymentOptionsWithCacheArgs): Promise<PaymentOptionsWithCacheResult> => {
  const cachedPaymentOptions = LocalStorage.getPaymentOptionsCache(merchantId)
  if (cachedPaymentOptions) {
    return { data: cachedPaymentOptions, fromCache: true }
  }

  const { data } = await BlazepayAPI.getPaymentOptions({ merchantId, filter })

  LocalStorage.setPaymentOptionsCache(merchantId, data)

  return { data, fromCache: false }
}
